import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import { RegionPage } from "@/components/calv/RegionPage";

export const Route = createFileRoute("/en/regions/aschaffenburg")({
  head: () => {
    const h = pageHead("region:aschaffenburg", "en");
    return { meta: h.meta, links: h.links };
  },
  component: () => <RegionPage slug="aschaffenburg" locale="en" />,
});
